<template>
  <div v-if="enabled" class="gallery-edge-nav">
    <button
      type="button"
      class="gallery-edge-nav__strip gallery-edge-nav__strip--left"
      :class="{ 'gallery-edge-nav__strip--visible': showLeft }"
      aria-label="Предыдущий объект"
      @click="$emit('previous')"
    >
      <span class="gallery-edge-nav__arrow" aria-hidden="true">←</span>
    </button>

    <button
      type="button"
      class="gallery-edge-nav__strip gallery-edge-nav__strip--right"
      :class="{ 'gallery-edge-nav__strip--visible': showRight }"
      aria-label="Следующий объект"
      @click="$emit('next')"
    >
      <span class="gallery-edge-nav__arrow" aria-hidden="true">→</span>
    </button>
  </div>
</template>

<script>
const EDGE_ZONE_PX = 50;
const NAV_HEIGHT_VAR = '--redbook-page-nav-height';

function pageNavHeightPx() {
  const raw = getComputedStyle(document.documentElement)
    .getPropertyValue(NAV_HEIGHT_VAR)
    .trim();
  const parsed = parseFloat(raw);
  return Number.isFinite(parsed) ? parsed : 0;
}

export default {
  name: 'GalleryEdgeNav',
  props: {
    enabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showLeft: false,
      showRight: false,
    };
  },
  mounted() {
    this.onMouseMove = this.handleMouseMove.bind(this);
    window.addEventListener('mousemove', this.onMouseMove);
  },
  beforeDestroy() {
    window.removeEventListener('mousemove', this.onMouseMove);
  },
  watch: {
    enabled(enabled) {
      if (!enabled) {
        this.showLeft = false;
        this.showRight = false;
      }
    },
  },
  methods: {
    handleMouseMove(event) {
      if (!this.enabled) {
        this.showLeft = false;
        this.showRight = false;
        return;
      }

      const { clientX, clientY } = event;
      const navHeight = pageNavHeightPx();

      if (clientY < navHeight) {
        this.showLeft = false;
        this.showRight = false;
        return;
      }

      const rightEdge = window.innerWidth - EDGE_ZONE_PX;

      this.showLeft = clientX <= EDGE_ZONE_PX;
      this.showRight = clientX >= rightEdge;
    },
  },
};
</script>

<style scoped>
.gallery-edge-nav__strip {
  position: fixed;
  top: var(--redbook-page-nav-height, 0px);
  bottom: 0;
  width: 72px;
  margin: 0;
  padding: 0;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #2f3540;
  color: #ffffff;
  cursor: pointer;
  z-index: 10;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
}

.gallery-edge-nav__strip--visible {
  opacity: 0.3;
  pointer-events: auto;
}

.gallery-edge-nav__strip--left {
  left: 0;
}

.gallery-edge-nav__strip--right {
  right: 0;
}

.gallery-edge-nav__strip--visible:hover {
  opacity: 0.3;
}

.gallery-edge-nav__arrow {
  font-size: 36px;
  line-height: 1;
  user-select: none;
}
</style>
